import { render, staticRenderFns } from "./reward-grant-form.vue?vue&type=template&id=2b7947a8&"
import script from "./reward-grant-form.vue?vue&type=script&lang=js&"
export * from "./reward-grant-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports